module.exports = __webpack_public_path__ + "img/object-weight-heavy.ed8db11.svg";